import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_TRASH_2: GlameraIconDefinition = {
  name: 'trash-2',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-trash-2-bar" d="M10 11v6"></path>
    <path class="glm-trash-2-bar" d="M14 11v6"></path>
    <path class="glm-trash-2-bin" d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
    <g class="glm-trash-2-lid">
      <path d="M3 6h18"></path>
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-trash-2-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './trash-2.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class Trash2IconComponent extends GlameraIconBase {
  readonly iconDef = GLM_TRASH_2;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
